import { mapboxAPI } from "../clients";

const ENDPOINT = `/mapbox.places`;
const ACCESS_TOKEN = process.env.VUE_APP_MAPBOX_TOKEN;

/**
 * The reverse geocoding query type allows you to look up a single pair of coordinates
 * @param {Object} data
 * @param {Number} data.latitude
 * @param {Number} data.longitude
 * @returns {Object} the geographic feature or features that exist at that location.
 */
const reverseGeocode = ({ latitude, longitude }) => {
  return mapboxAPI.get(
    `${ENDPOINT}/${latitude},${longitude}.json?access_token=${ACCESS_TOKEN}`,
    {
      access_token: ACCESS_TOKEN,
    }
  );
};

/**
 * The forward geocoding query type allows you to look up a single location by name
 * @param {Object} data
 * @param {String} data.query Query string (user input name of places)
 * @returns {Object} its geographic coordinates.
 */
const forwardGeocode = ({ query }) => {
  return mapboxAPI.get(
    `${ENDPOINT}/${query}.json?access_token=${ACCESS_TOKEN}`,
    {
      access_token: ACCESS_TOKEN,
    }
  );
};

export { reverseGeocode, forwardGeocode };
